export default __webpack_public_path__ + "static/maptiler-icon--small-ea20285f01bcb41316bea05744865006.png";